export default {
  home: '首頁',
  components: '组件',
  count_to_page: '数字渐变',
  tables_page: '多功能表格',
  split_pane_page: '分割窗口',
  markdown_page: 'Markdown編輯器',
  editor_page: '富文本編輯器',
  icons_page: '自定義圖標',
  img_cropper_page: '圖片編輯器',
  update: '上傳數據',
  join_page: 'QQ群',
  doc: '文檔',
  update_table_page: '上傳CSV文件',
  update_paste_page: '粘貼表格數據',
  multilevel: '多级菜单',
  directive_page: '指令',
  level_1: 'level-1',
  level_2: 'level-2',
  level_2_1: 'level-2-1',
  excel: 'Excel',
  'upload-excel': '上傳excel',
  'export-excel': '導出excel',
  tools_methods_page: '工具函數',
  drag_list_page: '拖拽列表',
  i18n_page: '多語言',
  modalTitle: '模態框題目',
  content: '這是模態框內容',
  buttonText: '顯示模態框',
  'i18n-tip': '注：僅此頁做了多語言，其他頁面沒有在多語言包中添加語言內容',
  error_store_page: '錯誤收集',
  error_logger_page: '錯誤日誌',
  user_manage: '用戶管理',
  account_manage: '賬號管理',
  role_manage: '角色管理',
  monitor: '監控',
  monitor_template: '監控模板',
  monitor_query: '監控查詢',
  alarm_metric: '告警策略',
  settings: '配置中心',
  interface: '界面配置',
  change_password: '修改密碼',
  ops_center: '操作中心',
  certificate_manage: '憑證管理',
  server_manage: '主機管理',
  script_manage: '腳本管理',
  cron_manage: '計劃任務管理',
  server_detail: '主機詳情',
  support_manage: '服務商管理',
  database: '數據庫管理',
  InstanceList: '實例列表,',
  CategoryList: '類型管理',
  ParamList: '參數管理',
  InstanceDetail: '實例詳情',
  alarm_logs: '告警記錄',
  cmdb: '資產管理',
  fixed_asset: '固定資產',
  MySQL: 'MySQL',
  SQLSERVER: 'SQLSERVER',
  MongoDB: 'MongoDB',
  mysqlInstanceInfo: 'MySQL基本信息',
  mysqlInstanceUser: 'MySQL账户管理',
  mysqlInstanceParam: 'MySQL参数设置',
  mysqlInstanceBackup: 'MySQL备份列表',
  mysqlInstanceLog: 'MySQL实例日志',
  mysqlInstanceOpsLog: 'MySQL操作日志',
  mysqlParamList: 'MySQL参数列表',
  mysqlInstanceSQL: 'MySQL执行SQL',
  mysqlInstanceDatabase: 'MySQL数据库管理',
  sqlserverInstanceInfo: 'SQLSERVER基本信息',
  sqlserverInstanceUser: 'SQLSERVER账户管理',
  sqlserverInstanceParam: 'SQLSERVER参数设置',
  sqlserverInstanceBackup: 'SQLSERVER备份列表',
  sqlserverInstanceLog: 'SQLSERVER实例日志',
  sqlserverInstanceOpsLog: 'SQLSERVER操作日志',
  sqlserverInstanceDatabase: 'SQLSERVER数据库管理',
  mongodbInstanceInfo: 'MongoDB基本信息',
  mongodbInstanceUser: 'MongoDB账户管理',
  mongodbInstanceParam: 'MongoDB参数设置',
  mongodbInstanceBackup: 'MongoDB备份列表',
  mongodbInstanceLog: 'MongoDB实例日志',
  mongodbInstanceOpsLog: 'MongoDB操作日志',
  mongodbInstanceDatabase: 'MongoDB数据库管理',
  mongodbInstanceNode: 'MongoDB节点列表',
  MySQLMigrate: '克隆数据列表',
  databaseDashboard: '数据库监控面板',
  privateCloud: '私有雲',
  compute: '計算',
  server: '實例',
  image: '鏡像',
  keyPairs: '密鑰對',
  storage: '存儲',
  volumes: '卷',
  backups: '備份',
  snapshots: '快照',
  net: '網絡',
  topology: '拓撲圖',
  network: '網絡',
  route: '路由',
  securityGroups: '安全組',
  floatingIps: '浮動IP',
  image_detail: '鏡像詳情',
  flavor: '實例類型',
  heart_config: '心跳設置'
}
